<template>
  <b-input-group>
    <b-input-group-prepend class="icon" :class="{ active: isActive }">
      <b-icon icon="search" class="ml-2"></b-icon>
    </b-input-group-prepend>
    <b-form-input
      type="search"
      v-model="filterValue"
      :placeholder="searchPlaceholder"
      @blur="isActive = false"
      @focus="isActive = true"
      @input="$emit('changeSearchValue', filterValue)"
    ></b-form-input>
  </b-input-group>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      filterValue: '',
    };
  },
  props: {
    searchPlaceholder: {
      default: 'Buscar',
      type: String,
    },
  },
};
</script>

<style scoped>
input,
input:focus,
.icon {
  border: 0.5px solid #333333;
}

input,
input:focus {
  border-left: none;
}

input {
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
  background-color: transparent;
}

input:focus {
  box-shadow: none;
  background-color: rgb(245, 245, 245);
}

::-webkit-input-placeholder {
  font-size: 16px;
  color: #615f5f;
}

.icon {
  border-right: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
}

.active {
  background-color: rgb(245, 245, 245);
}
</style>
